import { Navigate, Outlet } from "react-router";
import { App } from "../pages/app/app";
import { FAQPage } from "../pages/user/faqPage/faqPage";
import { IncomePage } from "../pages/user/incomePage/incomePage";
import { KnowledgeBasePage } from "../pages/user/knowledgeBasePage/knowledgeBasePage";
import { KnowledgeBaseTestPage } from "../pages/user/knowledgeBaseTestPage/knowledgeBaseTestPage";
import { KnowledgeBaseTestsPage } from "../pages/user/knowledgeBaseTestsPage/knowledgeBaseTestsPage";
import { MotivationPage } from "../pages/user/motivationPage/motivationPage";
import { ProfilePage } from "../pages/user/profilePage/profilePage";
import { SubscribePage } from "../pages/user/subscribePage/subscribePage";
import { TablePage } from "../pages/user/tablePage/tablePage";
import { TasksPage } from "../pages/user/tasksPage/tasksPage";
import { MainPage } from "../pages/user/mainPage/mainPage";
import { CheckListPage } from "../pages/user/checkListPage/checkListPage";
import { UserTemplate } from "../templates/user";
import { AdminTemplate } from "../templates/admin";
import { WorkersList } from "../pages/admin/workersList/workersList";
import { WorkerCardPage } from "../pages/admin/workerCard/workerCardPage";
import { WorkerMotivationPage } from "../pages/admin/workerMotivationPage/workerMotivationPage";
import { WorkerCheckListPage } from "../pages/admin/workerCheckListPage/workerCheckListPage";
import { WorkerTaskAddPage } from "../pages/admin/workerTaskAddPage/workerTaskAddPage";
import { AdminCheckListPage } from "../pages/admin/adminCheckList/adminCheckList";
import { AdminTaskAddPage } from "../pages/admin/adminTaskAddPage/adminTaskAddPage";
import { AdminTablePage } from "../pages/admin/adminTablePage/adminTablePage";
import { WorkerShiftAddPage } from "../pages/admin/addWorkerShiftPage/addWorkerShiftPage";
import { WorkerTablePage } from "../pages/admin/workerTablePage/tablePage";
import { SuperAdminTemplate } from "../templates/superadmin";
import { SuperadminKnowledgeBaseTestsPage } from "../pages/superadmin/knowledgeBaseTestsPage/adminKnowledgeBaseTestsPage";
import { CafeListPage } from "../pages/superadmin/cafeList/cafeListPage";
import { CafeInfo } from "../pages/superadmin/cafeInfo/cafeInfo";
import { EditCafeInfoPage } from "../pages/superadmin/editCafeInfo/editCafeInfo";
import { CafeTablePage } from "../pages/superadmin/cafeTablePage/cafeTablePage";
import { CafeWorkersPage } from "../pages/superadmin/cafeWorkers/cafeWorkers";
import { SuperAdminWorkerCardPage } from "../pages/superadmin/workerCard/workerCardPage";
import { SuperAdminWorkerMotivationPage } from "../pages/superadmin/workerMotivationPage/workerMotivationPage";
import { SuperAdminWorkerCheckListPage } from "../pages/superadmin/workerCheckListPage/workerCheckListPage";
import { SuperAdminWorkerTablePage } from "../pages/superadmin/workerTablePage/tablePage";
import { CreateCafePage } from "../pages/superadmin/addCafe/addCafe";
import { CafeKPIPage } from "../pages/superadmin/cafeKPIPage/cafeKPIPage";
import { AddKPITaskPage } from "../pages/superadmin/addKpiTask/addKpiTask";
import { SuperadminEditKPITaskPage } from "../pages/superadmin/editKpiTask/editKpiTask";
import { SuperadminAddTestPage } from "../pages/superadmin/addTest/addTest";
import { SuperadminAddCategoryPage } from "../pages/superadmin/addCategory/addCategory";
import { SuperadminAddMaterialPage } from "../pages/superadmin/addMaterial/addMaterial";
import { KnowledgeMaterialPage } from "../pages/user/knowledgeBaseMaterialPage/knowledgeMaterialPage";
import { SuperadminEditMaterialPage } from "../pages/superadmin/editMaterial/editMaterial";
import { SuperadminEditTestPage } from "../pages/superadmin/editTest/editTest";
import { AdminKnowledgeBasePage } from "../pages/admin/knowledgeBasePage/adminKnowledgeBasePage";
import { SuperadminKnowledgeBasePage } from "../pages/superadmin/knowledgeBasePage/adminKnowledgeBasePage";
import { AddCategoryPage } from "../pages/admin/addCategory/addCategory";
import { AdminKnowledgeBaseTestsPage } from "../pages/admin/knowledgeBaseTestsPage/adminKnowledgeBaseTestsPage";
import { EditTestPage } from "../pages/admin/editTest/editTest";
import { AddTestPage } from "../pages/admin/addTest/addTest";
import { EditMaterialPage } from "../pages/admin/editMaterial/editMaterial";
import { AddMaterialPage } from "../pages/admin/addMaterial/addMaterial";
import { AdminCafeInfo } from "../pages/admin/cafeInfo/cafeInfo";
import { ExpertsPage } from "../pages/user/experts/experts";
import { AdminCafeListPage } from "../pages/admin/cafeList/cafeListPage";
import { AdminCafeKPIPage } from "../pages/admin/cafeKPIPage/cafeKPIPage";
import { AdminAddKPITaskPage } from "../pages/admin/addKpiTask/addKpiTask";
import { AdminEditKPITaskPage } from "../pages/admin/editKpiTask/editKpiTask";
import { CafeAdminCheckListPage } from "../pages/superadmin/adminCheckList/adminCheckList";
import { ErrorBoundary } from "../components/errorBoundary/errorBoundary";
import { UserPolicyPage } from "../pages/policy/userPolicy";
import { AdminPolicyPage } from "../pages/policy/adminPolicy";
import { ChecklistTaskPage } from "../pages/user/checklistTaskPage/checklistTaskPage";
import { WorkerChecklistTaskPage } from "../pages/admin/workerChecklistTaskPage/checklistTaskPage";
import { CafeChecklistSettings } from "../pages/admin/cafeChecklistSettings/cafeChecklistSettings";
import { SuperadminCafeChecklistSettings } from "../pages/superadmin/cafeChecklistSettings/cafeChecklistSettings";
import { ReportsPage } from "../pages/user/reportsPage/reportsPage";
import { AddReportPage } from "../pages/user/addReportPage/addReportPage";
import { SuperAdminWorkerChecklistTaskPage } from "../pages/superadmin/workerChecklistTaskPage/checklistTaskPage";
import { WorkerReportsPage } from "../pages/admin/workerReportsPage/workerReportsPage";
import { SuperAdminWorkerReportsPage } from "../pages/superadmin/workerReportsPage/workerReportsPage";
import { CafeReportsPage } from "../pages/admin/cafeReportsPage/cafeReportsPage";
import { CreateCafeReportPage } from "../pages/admin/createReportPage/createReportPage";
import { SuperAdminCafeReportsPage } from "../pages/superadmin/cafeReportsPage/cafeReportsPage";
import { WorkerTaskEditPage } from "../pages/admin/workerTaskEditPage/workerTaskEditPage";
import { CafeFAQ } from "../pages/admin/cafeFaq/cafeFaq";
import { SuperAdminCafeFAQ } from "../pages/superadmin/cafeFaq/cafeFaq";
import { RevenueReportsPage } from "../pages/admin/revenueReports/revenueReports";
import { ComparativeRevenueReportPage } from "../pages/admin/comparativeRevenueReport/comparativeRevenueReportPage";
import { CafeMotivationPage } from "../pages/admin/cafeMotivationPage/CafeMotivationPage";
import { AuthTemplate } from "../templates/auth";
import { LoginPage } from "../pages/auth/login/loginPage";
import { RegisterPage } from "../pages/auth/register/registerPage";
import { DocumentsPage } from "../pages/user/documentsPage/documentsPage";
import { AdminProfilePage } from "../pages/admin/profilePage/profilePage";
import { AdminDocumentsPage } from "../pages/admin/documentsPage/documentsPage";
import { SuperAdminProfilePage } from "../pages/superadmin/profilePage/profilePage";
import { UpdatePasswordPage } from "../pages/auth/updatePassword/updatePassword";
import { LoginOtpPage } from "../pages/auth/loginOtp/loginOtpPage";
import { TwoFactorPage } from "../pages/auth/twoFactor/twoFactorPage";


/**
 * @typedef {Object} RouteObject
 * @property {string} [path] - Путь маршрута
 * @property {React.ComponentType} element - React-компонент для рендера
 * @property {RouteObject[]} [children] - Вложенные маршруты (опционально)
 * @property {boolean} [index]
 * @property {React.ReactNode} [errorElement]
 */

/**
 * @type (RouteObject[])
 */
export const routerConfig = [
    {
        path: "/",
        element: <App />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: "/",
                element: <UserTemplate />,
                children: [
                    {
                        path: "/",
                        element: <MainPage />
                    },
                    {
                        path: "tasks",
                        element: <TasksPage />
                    },
                    {
                        path: "income",
                        element: <IncomePage />
                    },
                    {
                        path: "profile",
                        element: <Outlet />,
                        children: [
                            {
                                index: true,
                                element: <ProfilePage />
                            },
                            {
                                path: "faq",
                                element: <FAQPage />
                            },
                            {
                                path: "subscribe",
                                element: <SubscribePage />
                            },
                            {
                                path: "motivation",
                                element: <MotivationPage />
                            },
                            {
                                path: "table",
                                element: <TablePage />
                            },
                            {
                                path: "reports",
                                children: [
                                    {
                                        index: true,
                                        element: <ReportsPage />,
                                    },
                                    {
                                        path: "add",
                                        element: <AddReportPage />
                                    }
                                ]
                            },
                            {
                                path: "documents",
                                element: <DocumentsPage />
                            }
                        ]
                    },
                    {
                        path: "knowledge",
                        children: [
                            {
                                index: true,
                                element: <KnowledgeBasePage />
                            },
                            {
                                path: "experts",
                                element: <ExpertsPage />
                            },
                            {
                                path: ":categoryId",
                                children: [
                                    {
                                        index: true,
                                        element: <KnowledgeBaseTestsPage />
                                    },
                                    {
                                        path: "experts",
                                        element: <ExpertsPage />
                                    },
                                    {
                                        path: "tests/:testId",
                                        element: <KnowledgeBaseTestPage />
                                    },
                                    {
                                        path: "materials/:materialId",
                                        element: <KnowledgeMaterialPage />
                                    },
                                ]

                            }
                        ]
                    },
                    {
                        path: "checklist",
                        children: [
                            {
                                index: true,
                                element: <CheckListPage />,
                            },
                            {
                                path: ":taskId",
                                element: <ChecklistTaskPage />,
                            }
                        ]
                    }
                ]
            },
            {
                path: "/admin",
                element: <AdminTemplate />,
                children: [
                    {
                        index: true,
                        element: <AdminCafeListPage />,
                    },
                    {
                        path: "comparative-revenue-report",
                        element: <ComparativeRevenueReportPage />,
                    },
                    {
                        path: "profile",
                        children: [
                            {
                                index: true,
                                element: <AdminProfilePage />
                            },
                            {
                                path: "documents",
                                element: <AdminDocumentsPage />,
                            }
                        ],
                    },
                    {
                        path: ":cafeId",
                        children: [
                            {
                                index: true,
                                element: <Navigate to="cafe" replace />
                            },
                            {
                                path: "profile",
                                children: [
                                    {
                                        index: true,
                                        element: <AdminProfilePage />
                                    },
                                    {
                                        path: "documents",
                                        element: <AdminDocumentsPage />,
                                    }
                                ],
                            },
                            {
                                path: "cafe",
                                children: [
                                    {
                                        index: true,
                                        element: <AdminCafeInfo />
                                    },
                                    {
                                        path: "zones",
                                        element: <CafeChecklistSettings />,
                                    },
                                    {
                                        path: "employees",
                                        children: [
                                            {
                                                index: true,
                                                element: <WorkersList />,
                                            },
                                            {
                                                path: ":userId",
                                                element: <WorkerCardPage />,
                                            },
                                            {
                                                path: ":userId/motivation",
                                                element: <WorkerMotivationPage />,
                                            },
                                            {
                                                path: ":userId/tasks",
                                                children: [
                                                    {
                                                        index: true,
                                                        element: <WorkerCheckListPage />,
                                                    },
                                                    {
                                                        path: "add",
                                                        element: <WorkerTaskAddPage />,
                                                    },
                                                    {
                                                        path: ":taskId",
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: <WorkerChecklistTaskPage />
                                                            },
                                                            {
                                                                path: "edit",
                                                                element: <WorkerTaskEditPage />
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        path: "edit",
                                                        element: <WorkerTaskEditPage />
                                                    },
                                                ]
                                            },
                                            {
                                                path: ":userId/table",
                                                children: [
                                                    {
                                                        index: true,
                                                        element: <WorkerTablePage />
                                                    },
                                                    {
                                                        path: "add",
                                                        element: <WorkerShiftAddPage />
                                                    }
                                                ]
                                            },
                                            {
                                                path: ":userId/reports",
                                                element: <WorkerReportsPage />
                                            }
                                        ]
                                    },
                                    {
                                        path: "table",
                                        children: [
                                            {
                                                index: true,
                                                element: <AdminTablePage />,
                                            },
                                            {
                                                path: "add",
                                                element: <WorkerShiftAddPage />
                                            }
                                        ]
                                    },
                                    {
                                        path: "motivation",
                                        element: <CafeMotivationPage />
                                    },
                                    {
                                        path: "reports",
                                        children: [
                                            {
                                                index: true,
                                                element: <CafeReportsPage />
                                            },
                                            {
                                                path: "create",
                                                element: <CreateCafeReportPage />
                                            }
                                        ]
                                    },
                                    {
                                        path: "faq",
                                        element: <CafeFAQ />
                                    },
                                    {
                                        path: "revenueReports",
                                        element: <RevenueReportsPage />
                                    }
                                ]
                            },
                            {
                                path: "reports",
                                children: [
                                    {
                                        index: true,
                                        element: <AdminCafeKPIPage />
                                    },
                                    {
                                        path: "add",
                                        element: <AdminAddKPITaskPage />
                                    },
                                    {
                                        path: "edit/:taskId",
                                        element: <AdminEditKPITaskPage />
                                    }
                                ]
                            },
                            {
                                path: "tasks",
                                children: [
                                    {
                                        index: true,
                                        element: <AdminCheckListPage />,
                                    },
                                    {
                                        path: "add",
                                        element: <AdminTaskAddPage />,
                                    }
                                ]
                            },
                            {
                                path: "knowledge",
                                children: [
                                    {
                                        index: true,
                                        element: <AdminKnowledgeBasePage />
                                    },
                                    {
                                        path: "add",
                                        element: <AddCategoryPage />
                                    },
                                    {
                                        path: ":categoryId",
                                        children: [
                                            {
                                                index: true,
                                                element: <AdminKnowledgeBaseTestsPage />
                                            },
                                            {
                                                path: "tests",
                                                children: [
                                                    {
                                                        path: ":testId",
                                                        element: <EditTestPage />
                                                    },
                                                    {
                                                        path: "add",
                                                        element: <AddTestPage />
                                                    }
                                                ]
                                            },
                                            {
                                                path: "materials",
                                                children: [
                                                    {
                                                        path: ":materialId",
                                                        element: <EditMaterialPage />,
                                                    },
                                                    {
                                                        path: "add",
                                                        element: <AddMaterialPage />
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                        ]
                    }
                ]
            },
            {
                path: "/superadmin",
                element: <SuperAdminTemplate />,
                children: [
                    {
                        index: true,
                        element: <Navigate to="/superadmin/cafe" replace />
                    },
                    {
                        path: "comparative-revenue-report",
                        element: <ComparativeRevenueReportPage />,
                    },
                    {
                        path: "profile",
                        children: [
                            {
                                index: true,
                                element: <SuperAdminProfilePage />,
                            },
                            {
                                path: "documents",
                                element: <AdminDocumentsPage />,
                            }
                        ],
                    },
                    {
                        path: "cafe",
                        children: [
                            {
                                index: true,
                                element: <CafeListPage />
                            },
                            {
                                path: ":cafeId",
                                children: [
                                    {
                                        index: true,
                                        element: <CafeInfo />
                                    },
                                    {
                                        path: "adminTasks",
                                        element: <CafeAdminCheckListPage />
                                    },
                                    {
                                        path: "editInfo",
                                        element: <EditCafeInfoPage />
                                    },
                                    {
                                        path: "zones",
                                        element: <SuperadminCafeChecklistSettings />,
                                    },
                                    {
                                        path: "table",
                                        children: [
                                            {
                                                index: true,
                                                element: <CafeTablePage />
                                            },
                                            {
                                                path: "add",
                                                element: <WorkerShiftAddPage />
                                            }
                                        ]
                                    },
                                    {
                                        path: "knowledge",
                                        children: [
                                            {
                                                index: true,
                                                element: <SuperadminKnowledgeBasePage />
                                            },
                                            {
                                                path: "add",
                                                element: <SuperadminAddCategoryPage />
                                            },
                                            {
                                                path: ":categoryId",
                                                children: [
                                                    {
                                                        index: true,
                                                        element: <SuperadminKnowledgeBaseTestsPage />
                                                    },
                                                    {
                                                        path: "tests",
                                                        children: [
                                                            {
                                                                path: ":testId",
                                                                element: <SuperadminEditTestPage />
                                                            },
                                                            {
                                                                path: "add",
                                                                element: <SuperadminAddTestPage />
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        path: "materials",
                                                        children: [
                                                            {
                                                                path: ":materialId",
                                                                element: <SuperadminEditMaterialPage />,
                                                            },
                                                            {
                                                                path: "add",
                                                                element: <SuperadminAddMaterialPage />
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        path: "employees",
                                        children: [
                                            {
                                                index: true,
                                                element: <CafeWorkersPage />
                                            },
                                            {
                                                path: ":userId",
                                                children: [
                                                    {
                                                        index: true,
                                                        element: <SuperAdminWorkerCardPage />
                                                    },
                                                    {
                                                        path: "motivation",
                                                        element: <SuperAdminWorkerMotivationPage />
                                                    },
                                                    {
                                                        path: "tasks",
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: <SuperAdminWorkerCheckListPage />,
                                                            },
                                                            {
                                                                path: ":taskId",
                                                                element: <SuperAdminWorkerChecklistTaskPage />,
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        path: "table",
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: <SuperAdminWorkerTablePage />
                                                            },
                                                            {
                                                                path: "add",
                                                                element: <WorkerShiftAddPage />
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        path: "reports",
                                                        element: <SuperAdminWorkerReportsPage />,
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        path: "kpi",
                                        children: [
                                            {
                                                index: true,
                                                element: <CafeKPIPage />
                                            },
                                            {
                                                path: "add",
                                                element: <AddKPITaskPage />
                                            },
                                            {
                                                path: "edit/:taskId",
                                                element: <SuperadminEditKPITaskPage />
                                            }
                                        ]
                                    },
                                    {
                                        path: "reports",
                                        children: [
                                            {
                                                index: true,
                                                element: <SuperAdminCafeReportsPage />
                                            }
                                        ]
                                    },
                                    {
                                        path: "faq",
                                        element: <SuperAdminCafeFAQ />
                                    }
                                ]
                            },
                            {
                                path: "create",
                                element: <CreateCafePage />
                            }
                        ]
                    },
                    {
                        path: "knowledge",
                        children: [
                            {
                                index: true,
                                element: <SuperadminKnowledgeBasePage />
                            },
                            {
                                path: "add",
                                element: <SuperadminAddCategoryPage />
                            },
                            {
                                path: ":categoryId",
                                children: [
                                    {
                                        index: true,
                                        element: <SuperadminKnowledgeBaseTestsPage />
                                    },
                                    {
                                        path: "tests",
                                        children: [
                                            {
                                                path: ":testId",
                                                element: <SuperadminEditTestPage />
                                            },
                                            {
                                                path: "add",
                                                element: <SuperadminAddTestPage />
                                            }
                                        ]
                                    },
                                    {
                                        path: "materials",
                                        children: [
                                            {
                                                path: ":materialId",
                                                element: <SuperadminEditMaterialPage />,
                                            },
                                            {
                                                path: "add",
                                                element: <SuperadminAddMaterialPage />
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                ]
            },
            {
                path: "/user_policy",
                element: <UserPolicyPage />
            },
            {
                path: "/admin_policy",
                element: <AdminPolicyPage />
            },
            {
                path: "/auth",
                element: <AuthTemplate />,
                children: [
                    {
                        index: true,
                        element: <Navigate to="login" replace />
                    },
                    {
                        path: "login",
                        element: <LoginPage />,
                    },
                    {
                        path: "register",
                        element: <RegisterPage />,
                    },
                    {
                        path: "login-otp",
                        element: <LoginOtpPage />,
                    },
                    {
                        path: "updatePassword",
                        element: <UpdatePasswordPage />
                    },
                    {
                        path: "twoFactor",
                        element: <TwoFactorPage />,
                    }
                ]
            },
            {
                path: "/invite/:inviteToken",
                element: <AuthTemplate />,
                children: [
                    {
                        index: true,
                        element: <RegisterPage />,
                    }
                ]
            }
        ]
    },
    {
        path: "*",
        element: <Navigate to="/" replace />
    }
]